import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SidePanel from '@/component/TwoColumnLayout/SidePanel';
import ContentPanel from '@/component/TwoColumnLayout/ContentPanel';
import PanelHeader from '@/component/TwoColumnLayout/PanelHeader';
import PanelContent from '@/component/TwoColumnLayout/PanelContent';

import styles from '../TwoColumnLayout/TwoColumnLayout.module.less';

/**
 * 三列布局，会话专用
 * SidePanel和Content沿用二列布局 增加中间布局MiddlePanel
 */

function ThreeColumnLayout({className, style, children}) {
    return (
        <div className={classNames(styles.container, className)} style={style}>
            {children}
        </div>
    );
}

ThreeColumnLayout.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.node,
};

ThreeColumnLayout.SidePanel = SidePanel;
ThreeColumnLayout.ContentPanel = ContentPanel;
ThreeColumnLayout.PanelHeader = PanelHeader;
ThreeColumnLayout.PanelContent = PanelContent;

export default ThreeColumnLayout;
